// extracted by mini-css-extract-plugin
export var border = "r_bG";
export var btnMono = "r_bF";
export var header = "r_c";
export var item = "r_P";
export var itemActive = "r_bD";
export var menu = "r_M";